import axios from 'axios';
import { getAccessToken } from './shared';
import { showWarningSnackbar } from '../components/snackBar/snakbar';
import { axiosInstanceForLambda } from './Axios';
import API_ENDPOINTS from '../apiEndpoints';

export const FetchGstInDetails = async (gstin) => {
  try {
    const options = {
      method: 'GET',
      url: `${API_ENDPOINTS.REACT_APP_FETCH_GSTIN_URL}?gstin=${gstin}`,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`, // Assuming Bearer token, adjust if needed
      },
    };
    let response = await axiosInstanceForLambda(options);
    return response;
  } catch (error) {
    console.log(error, 'error');
    if (
      JSON.parse(JSON.stringify(error.response.data)).error_cd === 'FO8000' ||
      JSON.parse(JSON.stringify(error.response.data)).error_cd === 'SWEB_9035'
    ) {
      showWarningSnackbar('GSTIN is NOT valid. Please recheck');
    } else {
      showWarningSnackbar('GST API is under maintenance, sorry for the inconvenience');
    }
    console.log(error);
    return null;
  }
};
